/* =====================================================
   MOECOSPLAY — UI Enhancement Scripts
   - Scroll-to-top button
   - Multicolumn overlay title extraction
   ===================================================== */

(function () {
    "use strict";

    var prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
    ).matches;

    /* ---------------------------------------------------
     * SCROLL-TO-TOP BUTTON
     * Injected into <body>; appears after scrolling 300px
     * --------------------------------------------------- */
    function initScrollToTop() {
        var btn = document.createElement("button");
        btn.className = "scroll-to-top";
        btn.setAttribute("aria-label", "Back to top");
        btn.setAttribute("title", "Back to top");
        btn.innerHTML = "&#8679;"; // ↑

        document.body.appendChild(btn);

        var ticking = false;

        window.addEventListener(
            "scroll",
            function () {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(function () {
                    if (window.scrollY > 300) {
                        btn.classList.add("visible");
                    } else {
                        btn.classList.remove("visible");
                    }
                    ticking = false;
                });
            },
            { passive: true },
        );

        btn.addEventListener("click", function () {
            if (prefersReducedMotion) {
                window.scrollTo(0, 0);
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        });
    }

    /* ---------------------------------------------------
     * MULTICOLUMN OVERLAY TITLE EXTRACTION
     * Reads the collection slug from the <a href> and
     * converts it to a readable title, e.g.:
     *   /collections/genshin-impact → "Genshin Impact"
     * Only runs when Liquid has left the span empty.
     * --------------------------------------------------- */
    function extractSlugTitle(href) {
        try {
            var parts = href.split("/").filter(Boolean);
            var slug = parts[parts.length - 1] || "";
            // Remove Shopify "shopify://" prefix if present
            if (slug.indexOf(":") !== -1) slug = slug.split(":").pop();
            return slug
                .split("-")
                .map(function (w) {
                    return w.charAt(0).toUpperCase() + w.slice(1);
                })
                .join(" ");
        } catch (_) {
            return "";
        }
    }

    function initMulticolumnOverlays() {
        document
            .querySelectorAll(".multicolumn-card__overlay")
            .forEach(function (overlay) {
                var titleEl = overlay.querySelector(
                    ".multicolumn-card__overlay-title",
                );
                if (!titleEl) return;
                if (titleEl.textContent.trim()) return; // Liquid already set a title

                var wrapper = overlay.closest(
                    ".multicolumn-card__image-wrapper",
                );
                if (!wrapper) return;

                var link = wrapper.querySelector("a[href]");
                if (!link) return;

                var title = extractSlugTitle(link.getAttribute("href") || "");
                if (title) titleEl.textContent = title;
            });
    }

    /* ---------------------------------------------------
     * INIT
     * --------------------------------------------------- */
    function init() {
        initScrollToTop();
        initMulticolumnOverlays();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
